export class GridData {
    colProp: string;
    rowProp: string;
    switchColWithRow: boolean = false;
    rowHeaders: any[];
    colHeaders: any[];
    matrix: any[];
}